module.exports = __webpack_public_path__ + "cf291c2a31eb87d47c83ce313f7273e8.mp3";